import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    document.title = 'Elevar Equity - Alternative Investment Fund Disclosures';
  }, []);

  return (
    <div className="home-container">
      {/* Skip to main content link */}
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>

      {/* Animated Background */}
      <div className="animated-background" aria-hidden="true">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
        <div className="grid-overlay"></div>
      </div>

      {/* Main Content */}
      <div className="content-wrapper">
        {/* Header/Logo Section */}
        <header className="header-section">
          <div className="logo-container">
            <img src="/img/logo.png" alt="Elevar Equity Logo" className="main-logo" />
          </div>
        </header>

        <main id="main-content">
          {/* Visually Hidden H1 for Accessibility */}
          <h1 className="sr-only">Elevar Equity - Alternative Investment Fund Disclosures</h1>

          {/* AIF Schemes Section */}
          <div className="aif-schemes-section">
            <h2 className="schemes-title">Our Investment Schemes</h2>
            <div className="schemes-grid">
              <Link to="/elevar-i-iv-aif" className="scheme-card scheme-card-primary" aria-label="Elevar I-IV AIF">
                <div className="scheme-card-inner">
                  <h3 className="scheme-name">Elevar I-IV AIF</h3>
                  <p className="scheme-description">SEBI Registered Category II Alternative Investment Fund</p>
                  <div className="scheme-meta">
                    <span className="scheme-reg">IN/AIF2/18-19/0545</span>
                    <span className="scheme-date">Registered: 21-May-2018</span>
                  </div>
                  <div className="scheme-arrow" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </div>
              </Link>
              
              <Link to="/ee-fi-aif" className="scheme-card scheme-card-secondary" aria-label="EE-Fi AIF">
                <div className="scheme-card-inner">
                  <h3 className="scheme-name">EE-Fi AIF</h3>
                  <p className="scheme-description">SEBI Registered Category II Alternative Investment Fund</p>
                  <div className="scheme-meta">
                    <span className="scheme-reg">IN/AIF2/21-22/0927</span>
                    <span className="scheme-date">Registered: 02-Sep-2021</span>
                  </div>
                  <div className="scheme-arrow" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          {/* Contact Section */}
          <div className="contact-section">
            <h2 className="contact-title">Contact</h2>
            <div className="contact-info">
              <p className="contact-label">Compliance Officer</p>
              <a 
                href="mailto:cco@elevarequity.com" 
                className="contact-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Email Compliance Officer at cco@elevarequity.com"
              >
                <div className="contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <span>cco@elevarequity.com</span>
              </a>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="footer-section">
          <p>©{currentYear} Elevar Equity. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default Home;
